import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../axios";

export const fetchInfoOrder = createAsyncThunk(
  "order/fetchInfoOrder",
  async () => {
    const { data } = await axios.get("/api/user/info/orders");
    if (data && data.items) {
      return Array.isArray(data.items) ? data.items : [];
    }
    return Array.isArray(data) ? data : [];
  }
);

export const updateOrder = createAsyncThunk(
  "order/updateOrder",
  async values => {
    const newData = {
      address: values.address,
      intercom: values.intercom,
      comment: values.comment,
    };
    const { data } = await axios.put(`/api/order/${values.id}`, newData);
    return data;
  }
);

export const cancelOrder = createAsyncThunk(
  "order/cancelOrder",
  async orderId => {
    const { data } = await axios.put(`/api/order/cancel/${orderId}`);
    return data;
  }
);

const initialState = {
  order: {
    items: [],
    status: "loading",
  },
};

const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchInfoOrder.pending, state => {
        state.order.status = "loading";
        state.order.items = [];
      })
      .addCase(fetchInfoOrder.fulfilled, (state, action) => {
        state.order.status = "loaded";
        state.order.items = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(fetchInfoOrder.rejected, state => {
        state.order.status = "error";
        state.order.items = [];
      })
      .addCase(updateOrder.fulfilled, (state, action) => {
        const updatedOrder = action.payload;
        state.order.items = state.order.items.map(item =>
          item._id === updatedOrder._id ? updatedOrder : item
        );
      })
      .addCase(cancelOrder.fulfilled, (state, action) => {
        const cancelledOrder = action.payload;
        state.order.items = state.order.items.map(item =>
          item._id === cancelledOrder._id ? cancelledOrder : item
        );
      });
  },
});

export const orderReducer = orderSlice.reducer;
